import io from 'socket.io-client';
import { emitter } from '@/helpers/emitter';

class SocketClient {
  constructor(socketUrl) {
    socketUrl = socketUrl || httApp.socketUrl;
    this.socket = io(socketUrl, {
      transports: ['websocket'],
    });
    this.socketInit = false;
    this.lastConnected = new Date();
    this.init();
  }

  init() {
    /*
     * Connect to socket
     */
    this.socket.on('connect', function () {
      console.log('socket connect');
      // Things we do 1 time
      if (!this.socketInit) {
        this.socketInit = true;
        emitter.emit('socket:hasConnected');
      }
      clearInterval(socketClient.intervalReload);
      socketClient.intervalReload = setInterval(() => {
        if (this.connected) {
          socketClient.lastConnected = new Date();
        }
      }, 5000);
      socketClient.socket.emit('joinliveQuotes');
      if (httApp.joinedEconomicCalendar) {
        socketClient.joinEconomicCalendar();
      }
    });

    // For the currency heatmap
    this.socket.on('liveQuote', (quote) => {
      try {
        emitter.emit('socket:liveQuote', quote);
      } catch (err) {
        console.error(err);
      }
    });
    this.socket.on('live_spreads', (listSpreads) => {
      try {
        emitter.emit('socket:live_spreads', listSpreads);
      } catch (err) {
        console.error(err);
      }
    });

    /*
     * Disconnect from socket
     */
    this.socket.on('disconnect', function () {});

    /*
     * Reconnect to socket
     */
    this.socket.on('reconnect', function () {});

    /*
     * Connect error
     */
    this.socket.on('connect_error', function () {
      // Unable to connect...
      console.error('connect_error');
      //$('#chat-text').val("");
    });

    this.socket.on('economicData', (data) => {
      emitter.emit('socket:econReceiveCalendarData', {
        payload: {
          data: data,
        },
      });
    });

    //quotes sent live to tickers and market report
    this.socket.on('tickersData', (tickersData) => {
      try {
        emitter.emit('socket:updateTickersDivs', {
          payload: {
            data: tickersData,
          },
        });
      } catch (err) {
        console.log(err);
      }
    });
  }

  // For currency heat map
  getInitialQuote() {
    this.socket.emit('requestLiveQuotes', (initialQuotes) => {
      emitter.emit('socket:initialQuote', {
        payload: initialQuotes,
      });
    });
  }

  // Economic calendar functions
  // from EconomicCalendar.js
  joinEconomicCalendar() {
    this.socket.emit('joinEconomicCalendar');
    httApp.joinedEconomicCalendar = true;
  }
  eventDetails(id) {
    this.socket.emit('requestCalendarEventDetails', id, (event) => {
      try {
        emitter.emit('socket:econEventDescription', {
          payload: {
            data: event,
          },
        });
      } catch (err) {
        console.log(err);
      }
    });
  }
  economicCalendarEvents(startts, endts, limit) {
    return new Promise((resolve) => {
      this.socket.emit('economicCalendar', startts, endts, limit, (data) => {
        resolve(data);
      });
    });
  }

  economicCalendarCountries() {
    return new Promise((resolve) => {
      this.socket.emit('economicCalendarCountries', (data) => {
        resolve(data);
      });
    });
  }

  // Currency Strength Meter functions
  currencyStrengthHistory() {
    return new Promise((resolve) => {
      this.socket.emit('requestHistory', (data) => {
        resolve(data);
      });
    });
  }

  requestTickersList(pairs) {
    return new Promise((resolv) => {
      this.socket.emit('requestListTickers', { pairs: pairs }, (tickers) => {
        resolv(tickers);
      });
    });
  }

  joinPairs(pairs) {
    pairs.forEach((pair) => {
      if (httApp.joinedPairs.indexOf(pair) === -1) {
        httApp.joinedPairs.push(pair);
      }
    });
    this.socket.emit('joinPairs', { pairs: pairs });
  }
}

export const socketClient = new SocketClient();
export const socketClientClass = SocketClient;
